import {MGVideoElement} from "./mg-video-element/MGVideoElement";
import {autoSetup} from "./mg-video-element/auto-setup";

import "./style.css"

window.customElements.define("mg-video", MGVideoElement)

addEventListener("DOMContentLoaded", function() {
    autoSetup()
})
